var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('compTablelist',_vm._b({staticClass:"margin-layout",attrs:{"columns":_vm.columns}},'compTablelist',_vm.getCostTableProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }